import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'atw-video-admin-config',
  templateUrl: './video-admin-config.component.html',
  styleUrls: ['./video-admin-config.component.scss']
})
export class AtwVideoAdminConfig extends AtwUpdateDbComponent {
  /** object đang chọn */
  @Input() objectChoosing: any;
  /** Thiết bị hiện tại (desktop, tablet_portrait, tablet_landscape, mobile_portrait, mobile_landscape) */
  @Input() device: any;
  /** Dữ liệu class của thiết bị hiện tại */
  @Input() class: any;
  /** Dữ liệu config của thiết bị hiện tại */
  @Input() config: any;
  /** Dữ liệu staticdata */
  @Input() staticdata: any;
  /** Dữ liệu blocks_of_page */
  @Input() blocks_of_page: any;
  /** Loại trang (page, admin, ...) */
  @Input() type: any;

  isVisible = false;
  isCollapsed: boolean = false;
  srcInput: any;
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  @ViewChild('myInput') myInput: ElementRef;
  @Input() visibleConfigVideo: boolean = false;
  @Output() update = new EventEmitter();
  @Output() closeConfigTool = new EventEmitter();
  currentViewAll: any = {};
  styles_field = [
    {
      title: 'bo_goc',
      index: 1
    },
  ];

  placeHolder = "<iframe src='https://www.youtube.com/embed/qW3raOCefms'  title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' allowfullscreen></iframe>"

  configMode: 'basic' | 'advanced' = 'basic';
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    private http: HttpClient,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }


  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
    this.srcInput = this.initSrcInput;
  }

  ngOnChanges() {
    this.staticdata.accessibility ??= {};
    this.staticdata.type_video ??= 'youtube';
  }

  //Hàm update class
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
  //     })
  // }

  private get initSrcInput() {
    switch (this.staticdata.type_video) {
      case 'facebook': 
      case 'instagram':
        return this.staticdata.src;
      case 'tiktok':
        return this.staticdata.html;
      case 'youtube':
      default:
        return this.staticdata.iframe;
    }
  }

  SetDisplaySetting(value: any, type: string) {
    // kiểm tra xem src ban đầu đã có chọn cài đặt nào khác chưa, nếu đã có thì sẽ tồn tại dấu ?
    const isSet = this.objectChoosing.staticdata.src.includes('?');
    //nếu như chọn mở
    if (value) {
      // nếu đã có ? thì thêm &
      if (isSet)
        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src.replace(type + "=0", "controls=1");

      // chưa thì thêm ?
      else
        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src + "?" + type + "=1";

    }
    //nếu như chọn tắt
    else {
      // nếu mới chỉ chọn tắt âm thì xóa dấu ?
      if (this.objectChoosing.staticdata.src.includes('?' + type + '=1')) {

        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src.replace(type + "=1", "controls=0");
      }
      else if (this.objectChoosing.staticdata.src.includes('&' + type + '=1')) {
        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src.replace(type + "=1", "controls=0");
      }
      else {
        if (isSet)
          this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src + "&controls=0";
        else
          this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src + "?controls=0";
      }
    }

    this.updateStaticData();
  }


  // Xử lý lặp lại
  setLoop(value: any, type: string) {
    const codeVideo = this.objectChoosing.staticdata.code_video;
    // kiểm tra xem src ban đầu đã có chọn cài đặt nào khác chưa, nếu đã có thì sẽ tồn tại dấu ?
    const isSet = this.objectChoosing.staticdata.src.includes('?');
    //nếu như chọn mở
    if (value) {
      // nếu đã có ? thì thêm &
      if (isSet)
        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src + "&playlist=" + codeVideo + "&" + type + "=1";
      // chưa thì thêm ?
      else
        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src + "?playlist=" + codeVideo + "&" + type + "=1";

    }
    //nếu như chọn tắt
    else {
      // nếu đã chọn cái khác trước khi chọn tắt âm thì xóa dấu &
      if (this.objectChoosing.staticdata.src.includes('&' + type + '=1')) {
        if (type == "loop") {
          if (this.objectChoosing.staticdata.src.includes("&playlist=" + codeVideo + "&" + type + "=1"))
            this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src.replace("&playlist=" + codeVideo + "&" + type + "=1", "");
          else if (this.objectChoosing.staticdata.src.includes("?playlist=" + codeVideo + "&" + type + "=1&"))
            this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src.replace("playlist=" + codeVideo + "&" + type + "=1&", "");
          else if (this.objectChoosing.staticdata.src.includes("?playlist=" + codeVideo + "&" + type + "=1"))
            this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src.replace("?playlist=" + codeVideo + "&" + type + "=1", "");
        }
        else
          this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src.replace("&" + type + "=1", "");
      }
    }
    this.updateStaticData();
  }


  // Xử lý bật tắt âm thanh
  setMute(value: any, type: string) {
    // kiểm tra xem src ban đầu đã có chọn cài đặt nào khác chưa, nếu đã có thì sẽ tồn tại dấu ?
    const isSet = this.objectChoosing.staticdata.src.includes('?');
    //nếu như chọn mở
    if (value) {
      if (this.objectChoosing.staticdata.src.includes('?' + type + '=1')) {
        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src.replace("?" + type + "=1", "");
      }
      // nếu đã chọn cái khác trước khi chọn tắt âm thì xóa dấu &
      else if (this.objectChoosing.staticdata.src.includes('&' + type + '=1')) {
        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src.replace("&" + type + "=1", "");
      }

      // autoplay phải đi với mute, nên nếu không mute thì autoplay sẽ tự động set false (Xem tại https://developer.chrome.com/blog/autoplay/)
      this.staticdata.autoplay = false;
      this.setAutoplay(false, 'autoplay', true);
    }
    //nếu như chọn tắt
    else {
      // nếu đã có ? thì thêm &
      if (isSet)
        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src + "&" + type + "=1";

      // chưa thì thêm ?
      else
        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src + "?" + type + "=1";
    }
    this.updateStaticData();

  }


  // Xử lý Tự động phát
  setAutoplay(value: any, type: string, noUpdate?: any) {
    // kiểm tra xem src ban đầu đã có chọn cài đặt nào khác chưa, nếu đã có thì sẽ tồn tại dấu ?
    const isSet = this.objectChoosing.staticdata.src.includes('?');
    //nếu như chọn tắt
    if (!value) {
      if (this.objectChoosing.staticdata.src.includes('?' + type + '=1')) {
        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src.replace("?" + type + "=1", "");
      }
      // nếu đã chọn cái khác trước khi chọn Tự động phát thì xóa dấu &
      else if (this.objectChoosing.staticdata.src.includes('&' + type + '=1')) {
        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src.replace("&" + type + "=1", "");
      }
    }
    //nếu như chọn mở
    else {
      // nếu đã có ? thì thêm &
      if (isSet)
        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src + "&" + type + "=1";
      // chưa thì thêm ?
      else
        this.objectChoosing.staticdata.src = this.objectChoosing.staticdata.src + "?" + type + "=1";
    }
    if (!noUpdate) this.updateStaticData();
  }


  getYouTubeVideoID(url: string): string {
    const videoIDRegex = /(?:embed\/|watch\?v=|v\/|youtu\.be\/)([\w-]{11})/;
    const match = url.match(videoIDRegex);
    if (match && match[1]) {
      return match[1];
    } else {
      // Nếu không tìm thấy mã ID hợp lệ
      return '';
    }
  }


  /**
   * Cập nhật staticdata vào database.
   */
  // updateStaticData() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  //     .then((bool) => {
  //     });
  // }


  getLink(link: any) {
    switch (this.staticdata.type_video) {
      case 'facebook':
        this.getLinkFacebook(link);
        break;
      case 'instagram':
        this.getLinkInstagram(link);
        break;
      case 'tiktok':
        this.getLinkTiktok(link);
        break;
      case 'youtube':
      default:
        this.getLinkYoutube(link);
        break
    }
  }

  /**
   * Hàm này sẽ lấy link youtube mà người dùng nhúng vào
   * @param link 
   */
  private getLinkYoutube(link: any) {
    try {
      const linkSplit = link.split(/(https.*?")/).filter(Boolean);
      const srcVideo = linkSplit[1].replace('"', '');
      if (link.includes('iframe') && link.includes('youtube')) {
        // Chuyển đổi sang nocookie
        this.objectChoosing.staticdata.src = srcVideo.includes("youtube.com/embed")
          ? srcVideo.replace("youtube.com", "youtube-nocookie.com")
          : srcVideo;
        this.objectChoosing.staticdata.code_video = this.getYouTubeVideoID(srcVideo);
        this.objectChoosing.staticdata.is_mute = true;
        this.objectChoosing.staticdata.loop = false;
        this.objectChoosing.staticdata.controls = true;
        this.objectChoosing.staticdata.autoplay = false;

        this.objectChoosing.staticdata.iframe = link.includes("youtube.com/embed")
          ? link.replace("youtube.com", "youtube-nocookie.com")
          : link;
        this.srcInput = this.objectChoosing.staticdata.iframe;
        this.functionService.createMessage('success', "ban_da_thay_doi_thanh_cong_duong_dan_video");

        this.vhEventMediator.notifyOnConfigChanged({
          id: this.objectChoosing._id,
          updateIframe: true,
        });

        // this.updateSrc()
      } else {
        this.functionService.createMessage('error', 'duong_dan_sai_vui_long_doc_huong_dan_chen_ban_do_de_lay_duong_dan_dung');
      }
      this.updateStaticData();
    } catch (error) {
      this.functionService.createMessage('error', 'vui_long_lam_theo_huong_dan_de_lay_duoc_duong_dan_chinh_xac',);
    }
  }

  /**
   * Hàm này sẽ lấy link tiktok mà người dùng nhúng vào
   */
  private getLinkTiktok(link: any) {
    try {
      const cleanInput = link.trim();

      // 1. Trường hợp link rút gọn từ App điện thoại (vt.tiktok.com hoặc vm.tiktok.com)
      if (cleanInput.includes('vt.tiktok.com') || cleanInput.includes('vm.tiktok.com')) {
        this.handleAppShortLink(cleanInput);
        return;
      }

      // 2. Trường hợp copy nguyên cục mã nhúng blockquote (có chứa data-video-id)
      if (cleanInput.includes('data-video-id=')) {
        const matchId = cleanInput.match(/data-video-id="(\d+)"/);
        if (matchId && matchId[1]) {
          this.updateTiktokSrc(matchId[1]);
          return;
        }
      }

      // 3. Trường hợp link Web thông thường (Trích xuất ID trực tiếp)
      const videoId = this.extractIdFromWebUrl(cleanInput);
      if (videoId) {
        this.updateTiktokSrc(videoId);
      } else {
        console.error('Không tìm thấy ID video TikTok hợp lệ');
      }
    } catch (error) {
      this.functionService.createMessage('error', 'vui_long_lam_theo_huong_dan_de_lay_duoc_duong_dan_chinh_xac');
    }
  }

  /**
   * Xử lý trích xuất ID từ URL Web (dùng Regex)
   */
  private extractIdFromWebUrl(url: string): string | null {
    const regex = /\/(?:video|embed\/v2|embed)\/(\d+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }

  /**
   * Xử lý link rút gọn từ App (Cần gọi qua một proxy/backend)
   */
  private handleAppShortLink(shortUrl: string): void {
    // Gọi qua API của unshorten.me công cộng
    const apiUrl = `https://unshorten.me/json/${encodeURIComponent(shortUrl)}`;

    this.http.get<{ resolved_url: string, success: boolean }>(apiUrl).subscribe({
      next: (res) => {
        if (res.success && res.resolved_url) {
          const videoId = this.extractIdFromWebUrl(res.resolved_url);
          if (videoId) {
            this.updateTiktokSrc(videoId);
            return;
          }
        }
      },
      error: (err) => {
        console.error('Lỗi API Unshorten:', err);
      }
    });
  }

  /**
   * Tạo link tiktok để gán vào staticdata
   */
  private updateTiktokSrc(videoId: string): void {
    this.staticdata.html = `
      <blockquote class="tiktok-embed" data-video-id="${videoId}" style="max-width: 605px; min-width: 325px; width: 100%; height: 100%;">
        <section></section>
      </blockquote>
      <script async src="https://www.tiktok.com/embed.js"></script>
    `;
    this.updateStaticData();
  }

  // Hàm cốt lõi để xử lý chuỗi
  getLinkFacebook(input: string) {
    // TRƯỜNG HỢP 1: Nếu đầu vào là một đoạn mã <iframe>, ta trích xuất nội dung trong thuộc tính src
    if (input.includes('<iframe')) {
      const srcMatch = input.match(/src="([^"]+)"/);
      this.staticdata.src = srcMatch ? srcMatch[1] : '';
      this.updateStaticData();
    }
    // TRƯỜNG HỢP 2: Nếu đầu vào là link share thông thường (bản chất là link rút gọn của FB)
    else if (input.includes('facebook.com')) {
      // Mã hóa link gốc để đưa vào tham số href của plugin Facebook
      const encodedUrl = encodeURIComponent(input);
      this.staticdata.src = `https://www.facebook.com/plugins/video.php?href=${encodedUrl}&show_text=false`;
      this.updateStaticData();
    }
  }

  /**
   * Hàm cốt lõi: Biến đổi mọi loại chuỗi Instagram thành Link Embed an toàn
   * @param input Chuỗi link gốc hoặc đoạn mã Blockquote bài viết
   */
  getLinkInstagram(input: string) {
    // Regex tìm kiếm ID bài viết sau các cụm /p/, /reel/, hoặc /tv/
    const regex = /\/(?:p|reel|tv)\/([A-Za-z0-9_-]+)/;
    const match = input.match(regex);

    if (match && match[1]) {
      const videoId = match[1];
      // Tạo link embed chuẩn sạch
      this.staticdata.src = `https://www.instagram.com/p/${videoId}/embed/`;
      this.updateStaticData();
    }
  }


  /**
  * Hàm này dùng để mở rộng phần cấu hình.
  * @param field_text : trả về phần tử được chọn của mảng style_field
  */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  //hiển thị modal
  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }


  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Update nội dung 
   * @param fieldContent - Tên trường để cập nhật nội dung
   * @param isAriaLabel - Có phải là trường dạng aria-label không
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent(fieldContent, isAriaLabel = false) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        isAriaLabel 
        ? this.staticdata.accessibility?.[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
        : this.staticdata[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            // Trường hợp là content nằm trong staticdata và nằm bằng cấp với accessibility
            if (!isAriaLabel) {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            } 
            // Trường hợp là field nằm trong accessibility
            else {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata.accessibility?.[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata.accessibility[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }

}
